import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { ANNUALIZED_MFR_GMV_CATEGORY_GMV } from 'lib/networking/endpoints';

/**
 * useMfrCategoryGmv — per-category branded manufacturer GMV for the MSV sidebar.
 *
 * Hits GET /annualized-mfr-gmv/category-gmv. With no l1CategoryId → per-L1
 * breakdown; with one → per-L2 breakdown under that L1. Optional distributor
 * scope. Each row is { CAT_VALUE, MONITIZABLE_GMV }. Sourced from the same
 * MFR_GMV (branded) basis as the KPI, so the sidebar totals reconcile with the
 * "Annualized GMV" headline.
 *
 * Returns { data: { data: [ { CAT_VALUE, MONITIZABLE_GMV } ] }, loading, ... }.
 */
function useMfrCategoryGmv({
  l1CategoryId,
  distributorId,
  thirdPartyTag,
  manufacturerId,
  brandId,
  skip = false,
} = {}) {
  const params = useMemo(() => {
    const p = {};
    if (l1CategoryId) p.l1_category_id = l1CategoryId;
    if (distributorId) p.distributor_id = distributorId;
    if (thirdPartyTag) p.third_party_tag = thirdPartyTag;
    if (manufacturerId) p.manufacturer_id = manufacturerId;
    if (brandId) p.brand_id = brandId;
    return p;
  }, [l1CategoryId, distributorId, thirdPartyTag, manufacturerId, brandId]);

  return useGet(ANNUALIZED_MFR_GMV_CATEGORY_GMV, params, skip);
}

export default useMfrCategoryGmv;
